import { memo, ReactNode } from 'react';

import Markdown from '~/components/Markdown';

import styles from './SnackbarMarkdown.module.scss';

interface ISnackbarMarkdownProps {
  children?: ReactNode | undefined;
}
function SnackbarMarkdown({ children }: ISnackbarMarkdownProps): JSX.Element {
  return (
    <div className={styles.markdownContainer}>
      <Markdown>{children}</Markdown>
    </div>
  );
}

export default memo(SnackbarMarkdown);
